module.exports = __webpack_public_path__ + "01_2x.jpg?530c7860ddd2a687188c9021a0046476";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/01_2x.jpg
// module id = 79
// module chunks = 0